// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * Utilities for formatting person names in accounting views.
 */

/**
 * Person information for display.
 * Expects firstName and lastName as strings (can be empty).
 */
interface PersonInfo {
  firstName: string;
  lastName: string;
  key: string;
}

/**
 * Formats a person's name for display.
 * Uses firstName and lastName if available, otherwise falls back to key.
 */
export function formatPersonName(person: PersonInfo): string {
  const parts: string[] = [];
  if (person.firstName) {
    parts.push(person.firstName);
  }
  if (person.lastName) {
    parts.push(person.lastName);
  }
  return parts.length > 0 ? parts.join(' ') : person.key;
}
